import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import {
  PerformanceReviewProcessTimelineFragment,
  UpdateDeadlinePerformanceReviewProcessDocument,
} from 'generated/resources/graphql'
import moment from 'moment'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import ReminderNotificationCard from 'modules/performance_process/components/common/ReminderNotificationCard'
import { DeadlinePicker } from 'modules/performance_process/components/review/forms/Deadline'

export const Timeline: React.FC<{ review: PerformanceReviewProcessTimelineFragment }> = ({
  review,
}) => {
  const { id, endsAt, status } = review
  const endsAtAsDate = endsAt ? moment(endsAt).toDate() : null

  const [displayEndTime, setDisplayEndTime] = React.useState(endsAt ? endsAtAsDate : null)

  const [updateReviewDeadline, { loading }] = useMutation(
    UpdateDeadlinePerformanceReviewProcessDocument,
    {
      extractorFn: (data) => data.performanceMutations.updateDeadlinePerformanceReviewProcess,
    }
  )

  const handleEndTimeChange = (date: Date) => {
    setDisplayEndTime(date)
    if (!date) return
    if (date.toISOString() === endsAtAsDate?.toISOString?.()) return

    updateReviewDeadline({
      variables: {
        id: id,
        endsAt: date.toISOString(),
      },
    }).then((response) => {
      const result = handleResult(response, () => {
        // TODO: do something with form errors
      })

      if (result.success) {
        app.setFlash({
          type: 'correct',
          message: i18n.t('common.saved_successfully'),
        })
      }
    })
  }

  return (
    <Box gap="s32">
      <Box gap="s32">
        <Box gap="s16">
          <Text size="400" color="grey1000" weight="semibold">
            {i18n.t('performance_process.reviews.timeline_section.deadline.title')}
          </Text>
          <Text.Normal>
            {i18n.t('performance_process.reviews.timeline_section.deadline.description')}
          </Text.Normal>
          <Box flexDirection="row" gap="s16">
            <DeadlinePicker
              readonly={status === 'finished' || loading}
              date={displayEndTime}
              onChange={handleEndTimeChange}
            />
          </Box>
        </Box>

        <Box>
          <ReminderNotificationCard endsAt={displayEndTime} />
        </Box>
      </Box>
    </Box>
  )
}
